module.exports = __webpack_public_path__ + "static/media/window.0f7c56bd.svg";